import { api } from './client';

export type SubscriptionStatus = 'ACTIVE' | 'TRIAL' | 'GRACE' | 'EXPIRED' | 'CANCELLED';

export interface Subscription {
  id: string;
  tenantId: string;
  systemId: string;
  planId: string;
  status: SubscriptionStatus;
  startAt: string;
  endAt: string;
  graceEndAt?: string | null;
  createdAt: string;
  updatedAt: string;
  system?: {
    id: string;
    name: string;
    key: string;
  };
  plan?: {
    id: string;
    name: string;
    key: string;
  };
}

export const subscriptionApi = {
  getMySubscriptions: async () => {
    const response = await api.get<Subscription[]>('/api/subscriptions/my');
    return response.data;
  },
  
  subscribe: async (data: { systemId: string; planId: string }) => {
    const response = await api.post<Subscription>('/api/subscriptions', data);
    return response.data;
  },
  
  upgrade: async (subscriptionId: string, data: { planId: string }) => {
    const response = await api.patch<Subscription>(`/api/subscriptions/${subscriptionId}/upgrade`, data);
    return response.data;
  },
  
  cancel: async (subscriptionId: string) => {
    const response = await api.patch<Subscription>(`/api/subscriptions/${subscriptionId}/cancel`, {});
    return response.data;
  },
};
